export default "__VITE_ASSET__CHxG_okb__"